import { render, staticRenderFns } from "./LandingPagesList.vue?vue&type=template&id=7cd9432a&"
import script from "./LandingPagesList.vue?vue&type=script&lang=js&"
export * from "./LandingPagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports